import ColorAndSize from '@common/components/aftercare/ColorAndSize';
import ProductImage from '@moncler/components/product/ProductImage';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { SM } from '@utils/imageutils';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
const ExpressPaymentItem = (props) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const removeFromBag = useCallback(() => {
        const pid = props.item.id;
        const uuid = props.item.lineUUID || props.item.UUID;
        api.getMiniCart();
        api.removeFromBag(pid, uuid).then(() => props.onRemove());
    }, [props.item]);
    return (React.createElement("div", { className: "product-box" },
        React.createElement("div", { className: "product-box__image", "aria-hidden": "true" },
            React.createElement(ProductImage, { img: props.item.imgs, sizes: [SM], type: "F", tiletype: ((_a = props.item) === null || _a === void 0 ? void 0 : _a.isMbm) ? 'mbm' : '' })),
        React.createElement("div", { className: "product-box__content" },
            React.createElement("div", { className: "product-box__content-main" },
                React.createElement("p", { className: "product-box__name" },
                    React.createElement("span", { className: "product-box__product-name" }, props.item.productName),
                    React.createElement("span", { className: "product-box__price" }, props.item.price.sales.formatted)),
                React.createElement("p", { className: "product-quantity" },
                    t('bag.quantity'),
                    ": ",
                    props.item.quantity),
                React.createElement("div", { className: "product-box__info" }, ((_b = props.item) === null || _b === void 0 ? void 0 : _b.isParfum) ? (React.createElement("p", { className: "option-product__size" },
                    t('label.format'),
                    " ", (_d = (_c = props.item) === null || _c === void 0 ? void 0 : _c.parfumAttributes.productFamily.find((el) => el.id == props.item.id)) === null || _d === void 0 ? void 0 :
                    _d.format)) : (React.createElement(ColorAndSize, { item: props.item })))),
            React.createElement("div", { className: "product-box__content-aside" },
                React.createElement("button", { type: "button", className: "cta cta--remove", onClick: () => {
                        removeFromBag();
                        analytics.removeitem(props.item);
                    } }, t('button.remove'))))));
};
export default ExpressPaymentItem;
